export default "__VITE_ASSET__df11493f__"